import { render, staticRenderFns } from "./CardPanel.vue?vue&type=template&id=50a13481&scoped=true&"
import script from "./CardPanel.vue?vue&type=script&lang=js&"
export * from "./CardPanel.vue?vue&type=script&lang=js&"
import style0 from "./CardPanel.vue?vue&type=style&index=0&id=50a13481&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a13481",
  null
  
)

export default component.exports